import { __assign } from "tslib";
import React from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconPhone = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({ viewBox: "-3 -2 24 24" }, SVGprops),
        React.createElement("path", { d: "M16 18.9c-8.8 0-16-7.2-16-16h2c0 7.7 6.3 14 14 14v2Z" }),
        React.createElement("path", { d: "m16 18.9-1-.031V16.9h1v-3.2l-2.7-.7-2.1 2.1-.6-.3C8 13.5 5.5 11.1 4.1 8.3l-.3-.6 2.1-2.1-.7-2.7H2v1H0v-1c0-1.1.9-2 2-2h3.6c.7 0 1.3.5 1.5 1.1l.8 3.3c.1.5 0 1.1-.4 1.4L6.2 8c1.1 1.9 2.8 3.6 4.6 4.6l1.3-1.3c.4-.4.9-.5 1.4-.4l3.4.8c.7.2 1.1.8 1.1 1.5v3.6c0 1.2-.9 2.1-2 2.1Z" })));
};
